import React from "react"
import styled from "styled-components"

import Header from "./Header"
import Footer from "./Footer"
import GlobalStyles from "../styles/GlobalStyles"

const Background = styled.div`
  margin: 0;
  padding: 0;
`

const Layout = ({ children, light }) => {
  return (
    <>
      <GlobalStyles />
      <Background>
        {/* <Header light={light} /> */}
        {children}
        {!light && <Footer />}
      </Background>
    </>
  )
}

export default Layout
